module.exports = __webpack_public_path__ + "img/icon_map_71_on.0b4ccfac.png";